<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content" id="send-content">
        <el-row>
          <div class="header-title">结算审批</div>
        </el-row>
        <el-row v-if="type == 'send'" class="save-button">
          <el-col class="text-center" :span="2">
            <el-button type="primary" size="medium" @click="goBack"
              >保存</el-button
            >
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="medium" @click="handleSubmit"
              >保存并提交</el-button
            >
          </el-col>
        </el-row>
        <el-row class="detail-top">
          <el-col class="total-wrapper">
            <div class="total-left">总笔数：</div>
            <div class="total-right">
              {{ totalNum }}
              <span class="total-right bi">笔</span>
            </div>
          </el-col>
          <el-col class="total-wrapper">
            <div class="total-left">总金额：</div>
            <div class="total-right">
              {{ totalMoney }}
              <span class="total-right bi">元</span>
            </div>
          </el-col>
          <el-col class="table-right">
            <el-select v-model="value" @change="selectData" class="select-box">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              :loading="downloadLoading"
              type="primary"
              class="export-table"
              size="medium"
              icon="el-icon-document"
              @click="handleDownload"
            >
              导出
            </el-button>
          </el-col>
        </el-row>
        <el-row id="send-table">
          <ApeTable
            ref="sendapeTable"
            :data="dataList"
            :columns="columns"
            :loading="loadingStaus"
            :pagingData="pagingData"
            @switchPaging="switchPaging"
            highlight-current-row
          >
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="goAmountEdit(scope.row)">
                修改金额
              </el-button>
            </template>
          </el-table-column>
          </ApeTable>
        </el-row>
      </div>
    </PageHeaderLayout>
    <verification
      @dialogChanged="dialogChanged($event)"
      @onSuccess="handleSuccess($event)"
      :dialogVisible="dialogVisible"
      :mobile="mobile"
      :is_verify="false"
    />
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import Verification from "@/components/Verification";

const AMOUNT_OVERRIDE_PREFIX = "dailySettlementAmountOverride";
const AMOUNT_SEED_PREFIX = "dailySettlementAmountSeed";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    Verification,
  },
  data() {
    return {
      mobile: "",
      dialogVisible: false,
      id: 0,
      type: "",
      loadingStaus: true,
      options: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      value: "xlsx",
      bookType: "xlsx",
      columns: [
        {
          title: "姓名",
          value: "bank_account_name",
        },
        {
          title: "身份证号码",
          value: "id_number",
        },
        {
          title: "手机号码",
          value: "mobile",
        },
        {
          title: "收款账号",
          value: "bank_account_no",
        },
        {
          title: "结算金额",
          value: "money",
        },
        {
          title: "实收金额",
          value: "after_money",
        },
        {
          title: "个税",
          value: "now_tax_money",
        },
        {
          title: "预扣增值税和附加税",
          value: "added_tax_money",
          header_align: "center",
          align: "center",
          width: 180,
        },
        {
          title: "银行名称",
          value: "bank_name",
        },
        {
          title: "开户行名称",
          value: "bank_branch",
        },
        {
          title: "编码",
          value: "code",
        },
        {
          title: "下发通道",
          value: "send_type",
        },
        {
          title: "上传时间",
          value: "created_at",
        },
      ],
      baseInfo: {},
      dataList: [],
      exportList: [],
      downloadLoading: false,
      pagingData: {
        is_show: true,
        layout: "total, prev, pager, next",
        total: 0,
      },
      totalNum: 0,
      totalMoney: 0,
    };
  },
  methods: {
    getRecordIdentity(record = {}) {
      return (
        record.id ||
        record.detail_id ||
        record.customer_id ||
        record.user_id ||
        record.id_number ||
        ""
      );
    },
    getAmountSeedKey(batchId, detailId) {
      return `${AMOUNT_SEED_PREFIX}:${batchId}:${detailId}`;
    },
    getAmountOverridePrefix(batchId) {
      return `${AMOUNT_OVERRIDE_PREFIX}:${batchId}:`;
    },
    getAmountOverrideMap(batchId) {
      const map = {};
      const prefix = this.getAmountOverridePrefix(batchId);
      for (let i = 0; i < window.sessionStorage.length; i += 1) {
        const key = window.sessionStorage.key(i);
        if (!key || key.indexOf(prefix) !== 0) {
          continue;
        }
        try {
          const value = JSON.parse(window.sessionStorage.getItem(key));
          if (value && value.detail_id) {
            map[String(value.detail_id)] = value;
          }
        } catch (error) {
          console.log(error);
        }
      }
      return map;
    },
    applyLocalAmountOverrides(list = []) {
      const overrideMap = this.getAmountOverrideMap(this.id);
      return list.map((item) => {
        const detailId = String(this.getRecordIdentity(item));
        const override = overrideMap[detailId];
        if (!override) {
          return item;
        }
        return {
          ...item,
          salary_type: override.salary_type || item.salary_type,
          money: override.settlement_amount || item.money,
          unit_amount: override.unit_amount || item.unit_amount,
        };
      });
    },
    goAmountEdit(row) {
      const detailId = this.getRecordIdentity(row);
      if (!detailId) {
        this.$message.error("缺少人员标识，无法修改金额");
        return;
      }
      window.sessionStorage.setItem(
        this.getAmountSeedKey(this.id, detailId),
        JSON.stringify({
          baseInfo: this.baseInfo,
          detailInfo: row,
        })
      );
      this.$router.push({
        path: `${this.$route.matched[1].path}/${this.id}/edit-amount/${detailId}`,
        query: {
          from: "send",
        },
      });
    },
    async handleSuccess(e) {
      const res = await this.$api.sendDailyTask({
        batch_id: this.baseInfo.id,
        ...e,
      });
      if (res) {
        this.$message.success("提交成功，请等待系统审核!");
        this.goBack();
      }
    },
    goBack() {
      this.$router.push(this.$route.matched[1].path);
    },
    dialogChanged(state) {
      this.dialogVisible = state;
    },
    // 表单提交
    handleSubmit() {
      if (this.dataList.length <= 0) {
        return this.$message.error("提交失败，数据不能为空!");
      }
      this.dialogVisible = true;
      this.getStaffAudit();
    },
    //获取审核人员手机号
    async getStaffAudit() {
      let result = await this.$api.getStaffAudit();
      if (result) {
        this.mobile = result.mobile;
      }
    },
    selectData(e) {
      this.bookType = e;
    },

    async switchPaging() {
      this.init();
    },

    async handleDownload() {
      this.downloadLoading = true;
      import("@/excel/Export2Excel").then((excel) => {
        const tHeader = [
          "姓名",
          "证件号码",
          "手机号码",
          "收款账号",
          "结算金额",
          "实收金额",
          "个税",
          "预扣增值税和附加税",
          "银行名称",
          "开户行名称",
          "编码",
          "下发通道",
          "上传时间",
        ];
        const data = this.formatJson(this.exportList);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `审批任务${time}`;
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let {
          bank_account_name,
          id_number,
          mobile,
          bank_account_no,
          money,
          after_money,
          now_tax_money,
          added_tax_money,
          bank_name,
          bank_branch,
          code,
          send_type,
          created_at,
        } = v;
        return [
          bank_account_name,
          id_number,
          mobile,
          bank_account_no,
          money,
          after_money,
          now_tax_money,
          added_tax_money,
          bank_name,
          bank_branch,
          code,
          send_type,
          created_at,
        ];
      });
    },
    normalizeDetailItem(item = {}) {
      return {
        ...item,
        after_money: item.after_money || "-",
        now_tax_money: item.now_tax_money || "-",
        added_tax_money: item.added_tax_money || "-",
        bank_name: item.bank_name || "-",
        bank_branch: item.bank_branch || "-",
        code: item.code || "-",
        send_type: item.send_type || item.bank_code || "-",
      };
    },
    async init(type) {
      var _this = this;
      this.id = this.$route.params.batch_id;
      if (this.id) {
        this.loadingStaus = true;
        let args = {
          id: this.id,
        };
        let { base, detail } = await this.$api.getTaskMissionInfo(args);
        this.baseInfo = base;
        this.dataList = this.applyLocalAmountOverrides(detail).map((item) =>
          this.normalizeDetailItem(item)
        );
        this.totalNum = base.total_num || this.dataList.length;
        this.totalMoney = this.dataList.reduce(function(total, currentValue) {
          return _this.$utils.sumTotal(total, currentValue.money);
        }, 0);
        this.exportList = this.dataList;
        let pagingInfo = this.$refs["sendapeTable"].getPagingInfo(type);
        this.pagingData.total = this.dataList.length;
        this.dataList = this.dataList.slice(
          pagingInfo.current_page * 10 - 10,
          pagingInfo.current_page * 10,
        );
      }
      this.loadingStaus = false;
    },
  },
  updated() {
    this.type = this.mxGetQuery("type") || "send";
    if (this.type != "send") {
      this.$refs["sendapeTable"].handleCurrentChange(1);
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0;
  margin-right: 12px;
}

.submitBtn {
  float: right;
  margin-top: 20px;
}

.link-url {
  color: #fff;
  text-decoration: none;
}

.title {
  font-size: 32px;
}

.desc {
  margin-bottom: 30px;
}

.center {
  display: flex;
  justify-content: center;
}

.text-center {
  text-align: center;
  margin-bottom: 20px;
}

.header-title {
  height: 53px;
  line-height: 53px;
  background-color: #1890ff;
  color: #fff;
  font-size: 20px;
  text-align: center;
}

.save-button {
  margin-bottom: 0;
}

#send-content {
  padding: 0;
}

#send-table {
  padding: 0 24px;
}

.detail-search {
  margin-left: 30px;
}

.total-wrapper {
  display: flex;
  flex-direction: row;
  padding: 0 10px;
  margin-top: 10px;
  margin-left: 15px;
  width: 270px;
}

.total-left {
  color: #606266;
  font-size: 16px;
  text-align: left;
}

.total-right {
  color: red;
  font-size: 15px;
}

.bi {
  color: #606266;
}

.detail-top {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.table-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 20px;
}

.select-box {
  margin-right: 20px;
  width: 100px;
}
</style>
